
import ReactDOM from 'react-dom/client';

import './styles.css'
import App from './App'

function Overlay() {
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', width: '100%', height: '100%',fontSize:'20px',fontWeight:'bold' }}>
      <a href="https://moondev.solutions/" style={{ position: 'absolute', bottom: 40, right: 40 }}>
       Moondev
      </a>
      <div style={{ position: 'absolute', top: 40, left: 40,  }}>Scroll Horizontally —</div>
    
    </div>
  )
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
    <Overlay />
   
  </>
)
